/**
 * Client-safe access to PUBLIC_* variables (Vite / SvelteKit build env).
 * Values come from `.env` at build time; empty string when unset.
 */

function str(v: unknown): string {
  if (v === undefined || v === null) return '';
  return String(v);
}

export function getPublicEnv(name: string): string {
  switch (name) {
    case 'PUBLIC_GOOGLE_ADS_ID':
      return str(import.meta.env.PUBLIC_GOOGLE_ADS_ID);
    case 'PUBLIC_GA4_MEASUREMENT_ID':
      return str(import.meta.env.PUBLIC_GA4_MEASUREMENT_ID);
    case 'PUBLIC_GADS_PURCHASE_LABEL':
      return str(import.meta.env.PUBLIC_GADS_PURCHASE_LABEL);
    case 'PUBLIC_GADS_CONVERSION_LABEL':
      return str(import.meta.env.PUBLIC_GADS_CONVERSION_LABEL);
    case 'PUBLIC_META_PIXEL_ID':
      return str(import.meta.env.PUBLIC_META_PIXEL_ID);
    case 'PUBLIC_TIKTOK_PIXEL_ID':
      return str(import.meta.env.PUBLIC_TIKTOK_PIXEL_ID);
    case 'PUBLIC_REDDIT_PIXEL_ID':
      return str(import.meta.env.PUBLIC_REDDIT_PIXEL_ID);
    case 'PUBLIC_GTM_ID':
      return str(import.meta.env.PUBLIC_GTM_ID);
    default:
      return str((import.meta.env as Record<string, unknown>)[name]);
  }
}

/** All defined PUBLIC_* keys used by analytics / layout (non-empty only). */
export function getPublicEnvRecord(): Record<string, string> {
  const out: Record<string, string> = {};
  const set = (key: string, value: string) => {
    if (value !== '') out[key] = value;
  };
  set('PUBLIC_GOOGLE_ADS_ID', str(import.meta.env.PUBLIC_GOOGLE_ADS_ID));
  set('PUBLIC_GA4_MEASUREMENT_ID', str(import.meta.env.PUBLIC_GA4_MEASUREMENT_ID));
  set('PUBLIC_GADS_PURCHASE_LABEL', str(import.meta.env.PUBLIC_GADS_PURCHASE_LABEL));
  set('PUBLIC_GADS_CONVERSION_LABEL', str(import.meta.env.PUBLIC_GADS_CONVERSION_LABEL));
  set('PUBLIC_META_PIXEL_ID', str(import.meta.env.PUBLIC_META_PIXEL_ID));
  set('PUBLIC_TIKTOK_PIXEL_ID', str(import.meta.env.PUBLIC_TIKTOK_PIXEL_ID));
  set('PUBLIC_REDDIT_PIXEL_ID', str(import.meta.env.PUBLIC_REDDIT_PIXEL_ID));
  set('PUBLIC_GTM_ID', str(import.meta.env.PUBLIC_GTM_ID));
  set('PUBLIC_POSTHOG_KEY', str(import.meta.env.PUBLIC_POSTHOG_KEY));
  set('PUBLIC_POSTHOG_HOST', str(import.meta.env.PUBLIC_POSTHOG_HOST));
  return out;
}
